import React from 'react';
import { withStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import styles from '../not_found_link/styles';

import Icon from './icon.svg';

const NotFound = ({ classes }) => {
    const { t } = useTranslation();
    return (
        <div className={classes.content}>
            <img src={Icon} className={classes.icon} alt="404"/>
            <p className={classes.mainText}>{t('Oops! We can’t seem to find the page you’re looking for.')}</p>
            <div className={classes.additionalText}>
                <p>{t('You may have mistyped the address or the page may have been moved.')}</p>
                <p>{t('For assistance please try our')}&nbsp;
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://vervoe.zendesk.com/hc/en-us"
                        className={classes.link}
                    >
                        {t('Help Centre')}
                    </a>
                </p>
            </div>
        </div>
    );
};

export default withStyles(styles)(NotFound);
